module.exports = __webpack_public_path__ + "static/media/tyrill-sample-card-comment.207645fe.png";